import {
  getEnrolledPrograms,
  getEnrolledRewards,
} from '@/types/programs-new/programs-new.utils'
import { ProgramsNew } from '@/types/programs-new/programs-new'

export function getProgramNamesWithExternalPayouts(
  programOverviews: ProgramsNew[],
): string[] {
  const enrolledPrograms = getEnrolledPrograms(programOverviews)
  const enrolledRewardPrograms = getEnrolledRewards(programOverviews)
  const externalPayoutRewardPrograms = enrolledRewardPrograms.filter(
    (reward) => reward.external_payout,
  )
  const programNamesForExternalPayoutRewardPrograms = enrolledPrograms
    .filter((program) =>
      externalPayoutRewardPrograms.some(
        (reward) => reward.utility_program === program.id,
      ),
    )
    .map((program) => program.name)
  return programNamesForExternalPayoutRewardPrograms
}
